import cn from 'classnames';
import { PopoverMenu } from '@/ui-components/molecules/PopoverMenu/PopoverMenu';
import { NavDropdownContentProps } from '../../NavHeader.type';
import styles from '../../navheader.module.scss';
import { NavDropdownSection } from './NavDropdownSection';

export interface NavDropdownItemProps {
    handleSearchClose: () => void;
    index: number;
    isDarkTheme: boolean;
    navDropdownContent: NavDropdownContentProps;
    navDropdownHoveredIndex: number | null;
    setHelpCenterHovered: (isHovered: boolean) => void;
    setNavDropdownHoveredIndex: (newIndex: number | null) => void;
    searchOpen: boolean;
    scheduleHoverClose: () => void;
    cancelHoverClose: () => void;
}

export function NavDropdownItem({
    handleSearchClose,
    index,
    isDarkTheme,
    navDropdownContent,
    navDropdownHoveredIndex,
    setHelpCenterHovered,
    setNavDropdownHoveredIndex,
    searchOpen,
    scheduleHoverClose,
    cancelHoverClose,
}: NavDropdownItemProps) {
    const isOpen = navDropdownHoveredIndex === index;

    const handleClick = () => {
        if (searchOpen) {
            setNavDropdownHoveredIndex(isOpen ? null : index);
            handleSearchClose?.();
            setHelpCenterHovered(false);
        }
    };

    return (
        <li
            key={index}
            onMouseEnter={() => {
                if (!searchOpen) {
                    cancelHoverClose();
                    setNavDropdownHoveredIndex(index);
                }
            }}
            onMouseLeave={() => {
                if (!searchOpen) {
                    scheduleHoverClose();
                }
            }}
        >
            <button
                className={cn(styles.navDropdownButton, {
                    [styles.darktheme]: isDarkTheme,
                })}
                onClick={handleClick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setNavDropdownHoveredIndex(index);
                        handleSearchClose?.();
                        setHelpCenterHovered(false);
                    } else if (e.key === 'Escape') {
                        setNavDropdownHoveredIndex(null);
                        setHelpCenterHovered(false);
                    }
                }}
                aria-expanded={isOpen}
                aria-label={navDropdownContent.label}
                data-type={`Navhover_${navDropdownContent.label.replace(/ /g, '')}`}
            >
                <span
                    className={cn(styles.navDropdown, {
                        [styles.darktheme]: isDarkTheme,
                    })}
                >
                    {navDropdownContent.label}
                </span>
            </button>
            <PopoverMenu
                fullWidthContent={<NavDropdownSection navDropdownContent={navDropdownContent} />}
                open={isOpen}
                onMouseEnter={cancelHoverClose}
                onMouseLeave={scheduleHoverClose}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        setNavDropdownHoveredIndex(null);
                        setHelpCenterHovered(false);
                    }
                }}
            />
        </li>
    );
}
